import React, { forwardRef, useMemo } from 'react';
import { List } from 'react-virtualized';
import { EadSimple } from '../context/ead-context';
import EadListItem from '../list-items/ead-item/ead-list-item';
import { useParams } from 'react-router-dom';
import { isSame } from '../context/utils/ead-tree-context-utils';
import AutoSizer from 'react-virtualized-auto-sizer';

const VirtualTree = forwardRef<List, { data: EadSimple[] }>(
  function VirtualTree({ data }: { data: EadSimple[] }, ref) {
    const { eadId } = useParams<{ eadId: string }>();

    const scrollToIndex = useMemo(
      () =>
        data.findIndex((n) =>
          isSame(n, { id: eadId, baseIdentifier: eadId } as EadSimple)
        ),
      [eadId, data]
    );

    return (
      <div
        style={{
          height: 'calc(100vh - 140px)',
          width: '100%',
          position: 'relative',
        }}
      >
        <AutoSizer style={{ width: '100%', height: '100%' }}>
          {
            //@ts-ignore
            ({ width, height }) => {
              return (
                <List
                  ref={ref}
                  height={height}
                  width={width}
                  rowHeight={40}
                  scrollToIndex={scrollToIndex}
                  scrollToAlignment="center"
                  rowCount={data.length}
                  rowRenderer={({ index, style, key }) => (
                    <EadListItem
                      data={data[index]}
                      style={style}
                      key={key}
                      index={index}
                    />
                  )}
                />
              );
            }
          }
        </AutoSizer>
      </div>
    );
  }
);

export default VirtualTree;
